import React, { useEffect, useState } from 'react';
import { Form, Input, InputNumber, Select, message, Card } from 'antd';
import { fetchSqlData, insertData } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/common/Button';

const { Option } = Select;

const ChemicalMaterialCreate: React.FC = () => {
  const [form] = Form.useForm();
  const [units, setUnits] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUnits();
  }, []);

  const fetchUnits = async () => {
    try {
      const res = await fetchSqlData('cor_units');
      setUnits(Array.isArray(res) ? res : res.data || []);
    } catch {
      setUnits([]);
    }
  };

  const handleFinish = async (values: any) => {
    setLoading(true);
    try {
      await insertData('mat_chemical_material', values);
      message.success('Chemical material added successfully.');
      navigate('/material/chemical-material');
    } catch (e: any) {
      if (e?.response?.data?.error && e.response.data.error.includes('unique')) {
        message.error('Material No must be unique.');
      } else {
        message.error('Failed to add material.');
      }
    }
    setLoading(false);
  };

  return (
    <Card title="Add Chemical Material" style={{ maxWidth: 600, margin: '0 auto' }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{ quantity: 0 }}
      >
        <Form.Item name="material_no" label="Material No" rules={[{ required: true, message: 'Please enter material no' }]}> <Input /> </Form.Item>
        <Form.Item name="description" label="Description"> <Input.TextArea rows={2} /> </Form.Item>
        <Form.Item name="quantity" label="Quantity" rules={[{ required: true, message: 'Please enter quantity' }]}> <InputNumber min={0} style={{ width: '100%' }} /> </Form.Item>
        <Form.Item name="unit_id" label="Unit" rules={[{ required: true, message: 'Please select unit' }]}> <Select placeholder="Select unit">{units.map((u: any) => (<Option key={u.id} value={u.id}>{u.name} ({u.symbol})</Option>))}</Select> </Form.Item>
        <Form.Item name="supplier" label="Supplier"> <Input /> </Form.Item>
        <Form.Item name="created_by" label="Created By"> <Input /> </Form.Item>
        <Form.Item>
          <Button action="add" type="primary" htmlType="submit" loading={loading}>Save</Button>
          <Button style={{ marginLeft: 8 }} onClick={() => navigate('/material/chemical-material')}>Cancel</Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ChemicalMaterialCreate; 